import { XObjectType, X_OBJECT_TYPE } from '../../../../../globals';
import { IsNever, SchemaTypeName } from '../../../primitives';
import { NestedSchema, RootSchema } from '../../../union';
import { ISchemaObject, ISchemaObjectProperties, StringKeys } from './object.types';
import { append, omit, pick } from './object.utils';

export * from './object.types';

/**  Types  */
export type ISchemaObjectInput<
    Properties extends ISchemaObjectProperties<StringKeys<Properties>>,
    RequiredProperties extends StringKeys<Properties>
> = Omit<
    ISchemaObject<Properties, RequiredProperties>,
    'type' | 'additionalProperties' | 'x-object-type'
> & {
    additionalProperties?: boolean;
};

/**
 * Property value is an object or array of objects
 * - Supports extraction of schema type from OneOfNullable<>
 * - No const, no enum
 */
export function object<
    Properties extends ISchemaObjectProperties<StringKeys<Properties>>,
    RequiredProperties extends StringKeys<Properties>
>(
    schema: RootSchema<ISchemaObjectInput<Properties, RequiredProperties>>
): RootSchema<ISchemaObject<Properties, RequiredProperties>>;
export function object<
    Properties extends ISchemaObjectProperties<StringKeys<Properties>>,
    RequiredProperties extends StringKeys<Properties>
>(
    schema: ISchemaObjectInput<Properties, RequiredProperties>
): NestedSchema<ISchemaObject<Properties, RequiredProperties>>;
export function object<
    Properties extends ISchemaObjectProperties<StringKeys<Properties>>,
    RequiredProperties extends StringKeys<Properties>
>(
    schema: ISchemaObjectInput<Properties, RequiredProperties>
): ISchemaObject<Properties, RequiredProperties> {
    return {
        [X_OBJECT_TYPE]: XObjectType.OBJECT,
        additionalProperties: false,
        ...schema,
        type: SchemaTypeName.object,
    };
}

/**
 * Append utilities
 */
object.append = append;
object.omit = omit;
object.pick = pick;

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = object({
    description: '',
    required: [],
    properties: {},
    $id: 'hello',
    title: '',
}).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = object({ description: '', required: [], properties: {} }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
